/* eslint-disable import/prefer-default-export */
import {useEffect, useCallback} from 'react';

/**
 * @description Convenience hook allowing subscription to the window's 'pageshow' event.
 * @param {function} callback - A Callback to run on pageshow event
 * @param {unknown[]} deps - A optional array of dependencies whose changes should refresh callback cache.
 * Similar to useEffect or useCallback.
 * */
export const useOnPageShow = (
  callback: () => void,
  deps: unknown[] = []
): void => {
  const cachedCallback = useCallback(callback, deps);
  useEffect(() => {
    window.addEventListener('pageshow', cachedCallback);
    return () => {
      window.removeEventListener('pageshow', cachedCallback);
    };
  }, [cachedCallback]);
};
